/*eslint-disable*/ import React from "react";
import styles from "pages-sections/services/ServicesSections.module.scss";
// nodejs library to set properties for components
import PropTypes from "prop-types";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
// @mui/icons-material
import FormatAlignLeft from "@mui/icons-material/FormatAlignLeft";
import Favorite from "@mui/icons-material/Favorite";
// core components
import Header from "components/Header/HeaderTribalism.js";
import HeaderLinks from "components/Header/HeaderLinksTribalism.js";
import Parallax from "components/Parallax/Parallax.js";
import Footer from "components/Footer/TribalismFooter.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
// sections for this page
import SectionText from "pages-sections/services/google-bigquery-training/SectionText.js";
import SectionBlogInfo from "pages-sections/blog-post/SectionBlogInfo.js";
import SectionComments from "pages-sections/blog-post/SectionComments.js";
import SectionSimilarStories from "pages-sections/blog-post/SectionSimilarStories.js";
import Section4Clients from "pages-sections/home-page/Section4ClientsLandingPage.js";
import Section8Contacts from "pages-sections/home-page/Section8Contacts.js";




export default function BlogPostPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = styles;
  return (
    <div>
      <Header
        brand="/img/clients/TribalismLogoRev.webp" 
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="transparent"
        title="Google BigQuery Training - Tribalism"
        image="/img/sections/services/all-services/8-sm.webp"
        url="https://www.tribalism.com.au/services/training/google-bigquery-training"
        type="article"
        description="We are a Data & Analytics Agency based in Melbourne. We regularly run training sessions all over Australia & Internationally! Our specialietis are analytics, search engine marketing and web design. "

        changeColorOnScroll={{
          height: 300,
          color: "info",
        }}
      />
      <Parallax image="/img/sections/services/all-services/8-sm.webp" filter="dark" small>
        <div className={classes.container}>
          <GridContainer justifyContent="center">
            <GridItem md={8} className={classes.textCenter}>
              <h1 className={classes.titleWhite}>
                Google BigQuery Training
              </h1>
              <br />
              <h4 className={classes.subtitleWhite}>
                <br />
              </h4>
              <br />
              <h4 className={classes.subtitleWhite}>
                Data & Analytics + SEM + Web Design
              <br />We help your digital platforms perform better
                </h4>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classes.main}>
        <div className={classes.container}>
          <SectionText />

        </div>
        <Section4Clients id="clients" />
          <Section8Contacts id="testimonials" />
      </div>
      <Footer
        content={
          <div>
            <div className={classes.left}>
              <List className={classes.list}>
                <ListItem className={classes.inlineBlock}>
                  <a
                    href="https://www.creative-tim.com/?ref=njsmkp-blog-post"
                    target="_blank"
                    className={classes.block}
                  >
                    Creative Tim
                  </a>
                </ListItem>
                <ListItem className={classes.inlineBlock}>
                  <a
                    href="https://www.creative-tim.com/presentation?ref=njsmkp-blog-post"
                    target="_blank"
                    className={classes.block}
                  >
                    About us
                  </a>
                </ListItem>
                <ListItem className={classes.inlineBlock}>
                  <a
                    href="https://blog.creative-tim.com/?ref=njsmkp-blog-post"
                    target="_blank"
                    className={classes.block}
                  >
                    Blog
                  </a>
                </ListItem>
                <ListItem className={classes.inlineBlock}>
                  <a
                    href="https://www.creative-tim.com/license?ref=njsmkp-blog-post"
                    target="_blank"
                    className={classes.block}
                  >
                    Licenses
                  </a>
                </ListItem>
              </List>
            </div>
            <div className={classes.right}>
              &copy; {1900 + new Date().getYear()} , made with{" "}
              <Favorite className={classes.icon} /> by{" "}
              <a
                href="https://www.creative-tim.com?ref=njsmkp-blog-post"
                target="_blank"
              >
                Creative Tim
              </a>{" "}
              for a better web.
            </div>
          </div>
        }
      />
    </div>
  );
}
